import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'
import { getEmojiFromCode } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'

const LikePill = ({ count, variant }) => {
  return (
    <div className={styles.likeWrapper}>
      <div className={`${styles.iconWrapper} ${styles[`${variant}Icon`]}`}>
        <Icon name='heart' size='large24' />
      </div>

      {count > 0 && <span className={`${styles.count} ${styles[`${variant}Count`]}`}>{count}</span>}
    </div>
  )
}

LikePill.propTypes = {
  count: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['gray', 'pink'])
}

LikePill.defaultProps = {
  variant: 'gray'
}

export default LikePill
